import type { PageExperience } from '@/features/experiences/types';
import { Box, Flex, Icon } from '@/ui';

type Props = {
  source: PageExperience['feeds'][number];
  isSelected: boolean;
  onToggle: (sourceId: string) => void;
};

export const SourceFilterRow = ({ source, isSelected, onToggle }: Props) => (
  <Flex
    _hover={{ bg: isSelected ? 'magicPurple.25' : 'rgba(0,0,0,0.03)' }}
    align="center"
    bg={isSelected ? 'magicPurple.25' : 'transparent'}
    borderRadius="ah-md"
    color={isSelected ? 'magicPurple.700' : 'ink.strong'}
    fontSize="ah-control"
    fontWeight={500}
    gap="8"
    px="2"
    py="2.5"
    role="button"
    tabIndex={0}
    transition="all 0.1s ease"
    w="100%"
    _focusVisible={{
      outline: '2px solid',
      outlineColor: 'magicPurple.300',
      outlineOffset: '1px',
    }}
    onClick={() => onToggle(source.id)}
    onKeyDown={(event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        // stop Space from scrolling the page
        event.preventDefault();
        onToggle(source.id);
      }
    }}
  >
    <Box flex="1" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
      {source.title}
    </Box>
    {isSelected && <Icon color="magicPurple.500" icon="Checkmark" size={4} />}
  </Flex>
);
